import script from "./ManageBrandCreateEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageBrandCreateEdit.vue?vue&type=script&setup=true&lang=js"

import "./ManageBrandCreateEdit.vue?vue&type=style&index=0&id=5f6983df&scoped=true&lang=css"

import exportComponent from "D:\\dev\\ai inventory\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f6983df"]])

export default __exports__